import { App } from 'vue'

import BsBtn from './btn/BsBtn'
import BsToggle from './toggle/BsToggle'
import BsForm, { BsFormRef } from './form/BsForm'
import BsTabStepper from './tabStepper/BsTabStepper'
import BsTabStepperTitle from './tabStepper/BsTabStepperTitle'
import BsInput from './input/BsInput'
import BsCheckbox from './checkbox/BsCheckbox'
import BsRadio from './radio/BsRadio'
import BsClickable from './clickable/BsClickable'
import BsTooltip from './tooltip/BsTooltip'
import BsChipBox from './chipBox/BsChipBox'
import BsDate from './date/BsDate'
import BsTabbedLayout from './tabbedLayout/BsTabbedLayout'
import BsFormField from './formField/BsFormField'
import BsUpgrade from './upgrade/BsUpgrade'
import BsSelect from './select/BsSelect'
import BsUpload from './upload/BsUpload'
import BsChip from './chip/BsChip'
import BsEditor from './editor/BsEditor'
import BsStatus from './status/BsStatus'
import BsModal from './modal/BsModal'
import BsSnippet from './snippet/BsSnippet'
import BsBtnDropdown from './btn/BsBtnDropdown'
import BsSiteBtn from './site-btn/BsSiteBtn'
import BsCheckToggle from './checkToggle/BsCheckToggle'
import BsRating from './rating/BsRating'
import BsShareBtn from './share-btn/BsShareBtn'
import BsPaginator from './paginator/BsPaginator'
import BsSelectBtn from './selectBtn/BsSelectBtn'
import BsImg from './img/BsImg'
import BsTag from './tag/BsTag'
import BsSpinner from './spinner/BsSpinner'
import BsFilterBtn from './btn/BsFilterBtn'

export {
  BsBtn,
  BsToggle,
  BsForm,
  BsInput,
  BsCheckbox,
  BsRadio,
  BsClickable,
  BsTooltip,
  BsChipBox,
  BsDate,
  BsTabStepper,
  BsTabStepperTitle,
  BsTabbedLayout,
  BsFormField,
  BsUpgrade,
  BsSelect,
  BsUpload,
  BsChip,
  BsEditor,
  BsStatus,
  BsModal,
  BsSnippet,
  BsBtnDropdown,
  BsSiteBtn,
  BsCheckToggle,
  BsRating,
  BsShareBtn,
  BsPaginator,
  BsSelectBtn,
  BsImg,
  BsTag,
  BsSpinner,
  BsFilterBtn
}

export type { BsFormRef }
export type { BsComponentRef } from './useBsComponent'
export type { BsInputRef } from './input/BsInput'
export type { BsChipBoxRef } from './chipBox/BsChipBox'
export type { BsUploadRef } from './upload/BsUpload'

export default {
  BsBtn,
  BsToggle,
  BsForm,
  BsTabStepper,
  BsTabStepperTitle,
  BsInput,
  BsCheckbox,
  BsRadio,
  BsClickable,
  BsTooltip,
  BsChipBox,
  BsDate,
  BsTabbedLayout,
  BsFormField,
  BsUpgrade,
  BsSelect,
  BsUpload,
  BsChip,
  BsEditor,
  BsStatus,
  BsModal,
  BsSnippet,
  BsBtnDropdown,
  BsSiteBtn,
  BsCheckToggle,
  BsRating,
  BsShareBtn,
  BsPaginator,
  BsSelectBtn,
  BsImg,
  BsTag,
  BsSpinner,
  BsFilterBtn,

  /**
   * A Vue 3 plugin: `install` is handed the APP, not the Vue constructor, and registration is
   * `app.component(...)`. The apps call this as `app.use(BsComponentBundle)` from their boot file.
   */
  install (app: App) {
    app.component('BsBtn', BsBtn)
    app.component('BsToggle', BsToggle)
    app.component('BsForm', BsForm)
    app.component('BsTabStepper', BsTabStepper)
    app.component('BsTabStepperTitle', BsTabStepperTitle)
    app.component('BsInput', BsInput)
    app.component('BsCheckbox', BsCheckbox)
    app.component('BsRadio', BsRadio)
    app.component('BsClickable', BsClickable)
    app.component('BsTooltip', BsTooltip)
    app.component('BsChipBox', BsChipBox)
    app.component('BsDate', BsDate)
    app.component('BsTabbedLayout', BsTabbedLayout)
    app.component('BsFormField', BsFormField)
    app.component('BsUpgrade', BsUpgrade)
    app.component('BsSelect', BsSelect)
    app.component('BsUpload', BsUpload)
    app.component('BsChip', BsChip)
    app.component('BsEditor', BsEditor)
    app.component('BsStatus', BsStatus)
    app.component('BsModal', BsModal)
    app.component('BsSnippet', BsSnippet)
    app.component('BsBtnDropdown', BsBtnDropdown)
    app.component('BsSiteBtn', BsSiteBtn)
    app.component('BsCheckToggle', BsCheckToggle)
    app.component('BsRating', BsRating)
    app.component('BsShareBtn', BsShareBtn)
    app.component('BsPaginator', BsPaginator)
    app.component('BsSelectBtn', BsSelectBtn)
    app.component('BsImg', BsImg)
    app.component('BsTag', BsTag)
    app.component('BsSpinner', BsSpinner)
    app.component('BsFilterBtn', BsFilterBtn)
  }
}
